import { NeoModel } from "@singularsystems/neo-core";
import { injectable } from "inversify";
import { IReportType } from "@singularsystems/neo-reporting/dist/Models/IReportType";
import WACToHoldingsReconciliationReport from "./WACToHoldingsReconciliationReport/WACToHoldingsReconciliationReport";
import NegativePortfolioBookPriceReport from "./NegativePortfolioBookPriceReport/NegativePortfolioBookPriceReport";
import SecurityHoldingsDataExtractReport from "./SecurityHoldingsDataExtract/SecurityHoldingsDataExtractReport";
import InstrumentsNeedingEnrichmentReport from "./InstrumentsNeedingEnrichmentReport/InstrumentsNeedingEnrichmentReport";
import BondsWithoutMaturityDateReport from "./BondsWithoutMaturityDate/BondsWithoutMaturityDateReport";
import CashNotCapitalisedReport from "./CashNotCapitalised/CashNotCapitalisedReport";
import CheckQueriesNotRunLastDayReport from "./CheckQueriesNotRunLastDay/CheckQueriesNotRunLastDayReport";
import CheckQueryConfigStatusReport from "./CheckQueryConfigStatusReport/CheckQueryConfigStatusReport";
import ClientsNotInConfigurationTableReport from "./ClientsNotInConfigurationTableReport/ClientsNotInConfigurationTableReport";
import DailyLogReportReport from "./DailyLogReport/DailyLogReportReport";
import EventsNotInConfigurationTableReport from "./EventsNotInConfigurationTable/EventsNotInConfigurationTableReport";
import ExcessiveScheduleTasksReport from "./ExcessiveScheduleTasks/ExcessiveScheduleTasksReport";
import ExportFilesSentReport from "./ExportFilesSent/ExportFilesSentReport";
import ImportStatusReport from "./ImportStatusReport/ImportStatusReport";
import ExchangeRatesPerDayExtractReport from "./ExchangeRatesForDayExtractReport/ExchangeRatesForDayExtractReport";
import IncompleteProcessReport from "./IncompleteProcess/IncompleteProcessReport";
import LatestBookValueHoldingsReport from "./LatestBookValueHoldings/LatestBookValueHoldingsReport";
import MismappedEventsReport from "./MismappedEvents/MismappedEventsReport";
import MissingAccountsReport from "./MissingAccounts/MissingAccountsReport";
import MissingImportsReport from "./MissingImports/MissingImportsReport";
import UnrecognisedImportFilesReport from "./UnrecognisedImportFiles/UnrecognisedImportFilesReport";
import InstrumentsWithNumericDisplayNamesReport from "./InstrumentsWithNumericDisplayNamesReport/InstrumentsWithNumericDisplayNamesReport";
import MaintenanceIndexFragmentationReport from "./MaintenanceIndexFragmentationReport/MaintenanceIndexFragmentationReport";
import ValuelessSecurityTransactionsReport from "./ValuelessSecurityTransactionsReport/ValuelessSecurityTransactionsReport";
import InstrumentsWithMultipleISINCodesReport from "./InstrumentsWithMultipleISINCodesReport/InstrumentsWithMultipleISINCodesReport";
import MissingExchangeRatesReport from "./MissingExchangeRates/MissingExchangeRatesReport";
import OpeningEntryIsSellReport from "./OpeningEntryIsSell/OpeningEntryIsSellReport";
import MaintenancePageSplitsReport from "./MaintenancePageSplits/MaintenancePageSplitsReport";
import MissingExchangeRateCombinationsReport from "./MissingExchangeRateCombinations/MissingExchangeRateCombinationsReport";
import InstrumentDetailsReport from "./InstrumentDetailsReport/InstrumentDetailsReport";
import SecurityReconReport from "./SecurityReconReport/SecurityReconReport";
import HistoricalRealisedGainOrLossReport from "./HistoricalRealisedGainOrLossReport/HistoricalRealisedGainOrLossReport";
import CashReconciliationReport from "./CashReconciliationReport/CashReconciliationReport";

@injectable()
@NeoModel
export default class MaintenanceReportingService {
    public getReports() {
        return [
            CashReconciliationReport,
            WACToHoldingsReconciliationReport,
            NegativePortfolioBookPriceReport,
            InstrumentsNeedingEnrichmentReport,
            HistoricalRealisedGainOrLossReport,
            BondsWithoutMaturityDateReport,
            CashNotCapitalisedReport,
            CheckQueriesNotRunLastDayReport,
            CheckQueryConfigStatusReport,
            ClientsNotInConfigurationTableReport,
            DailyLogReportReport,
            EventsNotInConfigurationTableReport,
            ExcessiveScheduleTasksReport,
            ExchangeRatesPerDayExtractReport,
            MissingExchangeRatesReport,
            ExportFilesSentReport,
            ImportStatusReport,
            IncompleteProcessReport,
            InstrumentDetailsReport,
            LatestBookValueHoldingsReport,
            MismappedEventsReport,
            MissingAccountsReport,
            MissingImportsReport,
            OpeningEntryIsSellReport,
            MissingExchangeRateCombinationsReport,
            MaintenancePageSplitsReport,
            InstrumentsWithNumericDisplayNamesReport,
            MaintenanceIndexFragmentationReport,
            SecurityHoldingsDataExtractReport,
            SecurityReconReport,
            ValuelessSecurityTransactionsReport,
            UnrecognisedImportFilesReport,
            InstrumentsWithMultipleISINCodesReport,
        ] as unknown as IReportType[]
    }
}